import { HttpMethods } from "../enums/HttpMethods";

class ContentFeedService {
  public static apiUrl = process.env.REACT_APP_CONTENT_FEED_API;
  public static apiToken = process.env.REACT_APP_AUTH_TOKEN;
  public static sendRequest<T>(
    method: HttpMethods,
    url: string,
    body?: T
  ): Promise<any> {
    const requestOptions: RequestInit = {
      method,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${this.apiToken}`,
      },
      body: JSON.stringify(body),
    };
    const requestUrl = `${this.apiUrl}/api/${url}`;

    return fetch(requestUrl, requestOptions)
      .then(response => response.json().then((data) => {
        if (!response.ok) {
          const error = new Error(data.error?.message || response.statusText || 'Unknown error occurred');
          error.name = String(response.status);

          throw error;
        }

        return data;
      })
      )
      .catch((error) => {
        throw error;
      });
  }
}

export default ContentFeedService;